import { useContext, useCallback } from 'react';
import { CAContext } from './src-contexts-CAContext.js';
import { getRestId, getRestIdWithoutCounter } from './src-utils-session-storage-utils.js';
import { logMapping } from './src-utils-chat-chat-nr-logging.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';

const useNRLogging = () => {
  const {
    chatState: { locale }
  } = useContext(CAContext);
  const {
    state: { sessionId }
  } = useContext(ChatbotContext);
  const initNR = useCallback(() => {
    const pageURL = window?.location.href;
    if (window && window?.newrelic) {
      return;
    }
    if (pageURL?.includes("localhost")) ;
  }, []);
  const logCustomAttributesNR = useCallback(
    (pageAction, attributes) => {
      let env;
      const pageURL = window?.location.href;
      if (pageURL?.includes("staging") || pageURL?.includes("localhost")) {
        env = "dev";
      } else env = "production";
      if (window && window?.newrelic && window?.newrelic.addPageAction) {
        window?.newrelic.addPageAction(pageAction, {
          ...attributes,
          environment: env,
          locale,
          caChatbotLogKey: getRestIdWithoutCounter(),
          caRequestID: getRestId(false),
          chatbotSessionId: sessionId || ""
        });
      }
    },
    [sessionId, locale]
  );
  const logChat = useCallback((logName, additionalInfo) => {
    let attributes = logMapping(logName, locale);
    const caLogKey = getRestIdWithoutCounter();
    if (typeof additionalInfo in ["boolean", "string", "number"]) {
      attributes = { ...attributes, additionalInfo };
    } else if (typeof additionalInfo === "object") {
      attributes = { ...attributes, ...additionalInfo };
    }
    const pageAction = "chat_anywhere";
    if (window && window.newrelic) {
      window.newrelic.addPageAction(pageAction, { ...attributes, caLogKey });
    }
  }, []);
  return { initNR, logCustomAttributesNR, logChat };
};

export { useNRLogging };
//# sourceMappingURL=src-hooks-custom-hooks-useNRLogging.js.map
